/**
 * Typ souboru dávky podle přípony, když ho prohlížeč nedá (soubory z přetažené složky, TIF
 * a HEIC v Chrome). Jeden zdroj pro přijetí souboru do dávky i rozhodnutí o zmenšení.
 */

/** Přípona (malými písmeny, bez tečky) → typ části multipartu, když prohlížeč typ nedá. */
export const BATCH_EXTENSION_TYPES: Readonly<Record<string, string>> = {
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  jfif: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  tif: "image/tiff",
  tiff: "image/tiff",
  heic: "image/heic",
  heif: "image/heif",
};

/** Sekvence HEIF/HEIC (živé fotky) → jednotlivý obrázek; serverový `validateImage` sekvence nezná. */
const SEQUENCE_TYPES: ReadonlyMap<string, string> = new Map([
  ["image/heic-sequence", "image/heic"],
  ["image/heif-sequence", "image/heif"],
]);

/** Přípona jména malými písmeny bez tečky; jméno bez tečky (nebo jen s úvodní) → "". */
function extensionOf(name: string): string {
  const dot = name.lastIndexOf(".");
  return dot > 0 ? name.slice(dot + 1).toLowerCase() : "";
}

/**
 * Prázdný typ → podle přípony (neznámá přípona → ""); `image/heic-sequence` → `image/heic`,
 * `image/heif-sequence` → `image/heif`; jinak `file.type`.
 */
export function uploadTypeOf(file: { type: string; name: string }): string {
  if (file.type === "") {
    const ext = extensionOf(file.name);
    return Object.prototype.hasOwnProperty.call(BATCH_EXTENSION_TYPES, ext)
      ? BATCH_EXTENSION_TYPES[ext]
      : "";
  }
  return SEQUENCE_TYPES.get(file.type) ?? file.type;
}
